<div #dialog class="lang-selct-confirm-modal-content" tabindex="0">
  <div class="container mt-0 p-0">
    <div class="row">
      <div class="col-sm-12 col-lg-6 col-md-6 lang-container-div">
        <div class="lang-title">{{ content1 }}</div>
        <button
          (click)="setPrefCookieOnSelect(true)"
          class="btn-keep btn btn-outline-secondary-cta rounded-0"
        >
          {{
            primaryLanguage?.countryName + ' - ' + primaryLanguage?.languageName
          }}
        </button>
        <div
          class="d-none d-sm-block bottom-gray-line offset-1 col-sm-10"
        ></div>
      </div>
      <div class="col-sm-12 col-lg-6 col-md-6 lang-container-div">
        <div class="lang-title">{{ content2 }}</div>
        <button
          (click)="setPrefCookieOnSelect(false)"
          class="btn-keep btn btn-outline-secondary-cta rounded-0 sec-lang-confirm-button"
        >
          {{
            secondaryLanguage?.countryName +
              ' - ' +
              secondaryLanguage?.languageName
          }}
        </button>
        <div
          class="d-none d-sm-block bottom-gray-line offset-1 col-sm-10"
        ></div>
      </div>
      <div class="col-12 other-lang-select">
        <a (click)="openCLS()" aria-haspopup="true" href="javascript:void(0);">
          <span class="select-lang-text">
            Select other Location and Language
          </span>
          <span aria-hidden="true" class="red-caret-image"></span>
        </a>
      </div>
    </div>
  </div>
</div>
